import * as THREE from 'three';

const $noren = document.querySelector('.brand-detail-noren');

if ($noren) {
  const $imgs = $noren.querySelectorAll('img');
  const $svg = $noren.querySelector('.is-svg-noren');

  const renderedW = () => $noren.clientWidth;
  const renderedH = () => $noren.clientHeight;

  const textureLoader = new THREE.TextureLoader();
  const scene = new THREE.Scene();

  const camera = new THREE.OrthographicCamera(
    -renderedW() / 2, renderedW() / 2,
    renderedH() / 2, -renderedH() / 2,
    1, 1000
  );
  camera.position.z = 500;

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(renderedW(), renderedH());
  $noren.appendChild(renderer.domElement);

  const $canvas = $noren.querySelector('canvas');

  // 寸法は可変にする（リサイズで更新）
  let PANEL_W = renderedW() / 3;
  let PANEL_H = renderedH();
  let START_X = -PANEL_W;
  const TOP_Y = 0;

  const colors = [0xffffff, 0xffffff, 0xffffff];

  // テクスチャは一度だけ読み込んでキャッシュ（リサイズ時の再ロードを防ぐ）
  const textures = [];

  let panels = [];

  const createPanel = index => {
    const geometry = new THREE.PlaneGeometry(PANEL_W, PANEL_H, 20, 28);

    if (!textures[index]) {
      const src = $imgs[index].getAttribute('src');
      const texture = textureLoader.load(src);
      texture.colorSpace = THREE.SRGBColorSpace;
      textures[index] = texture;
    }

    const material = new THREE.MeshBasicMaterial({
      map: textures[index],
      transparent: true,
      color: colors[index],
      side: THREE.DoubleSide
    });

    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.x = START_X + index * PANEL_W;
    mesh.position.y = TOP_Y;
    scene.add(mesh);

    panels.push({
      mesh,
      geometry,
      material,
      basePositions: geometry.attributes.position.array.slice(),
      index
    });
  }

  const buildPanels = () => {
    // 既存パネルを破棄
    panels.forEach(p => {
      scene.remove(p.mesh);
      p.geometry.dispose();
      p.material.dispose();
    });
    panels = [];

    // 現在の寸法で再計算
    PANEL_W = renderedW() / 3;
    PANEL_H = renderedH();
    START_X = -PANEL_W;

    createPanel(0);
    createPanel(1);
    createPanel(2);
  }

  buildPanels();

  $imgs.forEach($img => ($img.style.opacity = 0));
  $canvas.style.opacity = 1;

  // 位相をずらす（暖簾ごとに開始タイミング・速度を変える）
  let time = Math.random() * 100;
  const speedFactor = 0.9 + Math.random() * 0.2;

  const easePulse = t => {
    const cycle = t % 5.5;
    if (cycle > 1.25) return 0;
    const x = cycle / 1.25;
    return Math.sin(x * Math.PI);
  }

  const animate = () => {
    requestAnimationFrame(animate);
    time += 0.016 * speedFactor;

    const baseWind = Math.sin(time * 1.2) * 0.5 + 0.5;
    const liftPulse = easePulse(time);

    panels.forEach((panel) => {
      const pos = panel.geometry.attributes.position;
      const arr = pos.array;
      const base = panel.basePositions;

      for (let i = 0; i < arr.length; i += 3) {
        const x = base[i];
        const y = base[i + 1];

        const u = (x + PANEL_W / 2) / PANEL_W;
        const v = 1 - ((y + PANEL_H / 2) / PANEL_H);

        const bottomPower = Math.pow(v, 2.2);
        const rightPower = Math.pow(u, 2.4);

        const panelDelay = panel.index * 0.35;
        const wave = Math.sin(time * 2.2 + u * 3.5 + panelDelay) * 5;

        let dx = wave * bottomPower * (0.25 + panel.index * 0.25);
        let dy = Math.sin(time * 1.7 + u * 2.5) * 4 * bottomPower;

        if (panel.index === 2) {
          const lift = (baseWind * 0.18 + liftPulse * 1.0) * bottomPower * rightPower;
          dy += lift * 110;
          dx -= lift * 30;
          dx += Math.sin(time * 3.0 + v * 4.0) * 8 * bottomPower * rightPower;
        }
        if (panel.index === 1) {
          const follow = liftPulse * bottomPower * Math.pow(u, 1.6);
          dy += follow * 24;
          dx -= follow * 8;
        }
        if (panel.index === 0) {
          dy *= 0.35;
          dx *= 0.35;
        }

        arr[i] = x + dx;
        arr[i + 1] = y + dy;
        arr[i + 2] = base[i + 2];
      }
      pos.needsUpdate = true;
    });

    renderer.render(scene, camera);
  }
  animate();

  // リサイズ処理（デバウンス付き）
  const onResize = () => {
    camera.left = -renderedW() / 2;
    camera.right = renderedW() / 2;
    camera.top = renderedH() / 2;
    camera.bottom = -renderedH() / 2;
    camera.updateProjectionMatrix();

    renderer.setSize(renderedW(), renderedH());

    buildPanels();
  }

  let resizeTimer;
  const ro = new ResizeObserver(() => {
    clearTimeout(resizeTimer);
    setTimeout(onResize, 150);
  });
  ro.observe($noren);

  if ($svg) {
    const hems = [
      'M615 228H309H0',
      'M615 228C615 228 431 167.5 299.5 167.5C168 167.5 0 228 0 228',
      'M615 228C615 228 506.766 238.338 470 218C395.288 176.67 355.956 88.5 301 88.5C247.645 88.5 209.29 176.737 138 218C99.7255 240.154 0 228 0 228',
      'M615 228C615 228 540.766 238.338 504 218C429.288 176.67 720 0 307.5 0C-105 0 185.29 176.737 114 218C75.7255 240.154 0 228 0 228'
    ];

    const shape = $svg.querySelector('.is-shape');

    // 各裾カーブを等間隔サンプリング（両端は厳密に固定）
    const SAMPLES = 240;
    const probe = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    probe.setAttribute('visibility', 'hidden');
    shape.ownerSVGElement.appendChild(probe);
    const hemPts = hems.map(d => {
      probe.setAttribute('d', d);
      const L = probe.getTotalLength(), pts = [];
      for (let i = 0; i <= SAMPLES; i++) {
        const p = probe.getPointAtLength(L * i / SAMPLES);
        pts.push([p.x, p.y]);
      }
      pts[0] = [615, 228];
      pts[SAMPLES] = [0, 228];
      return pts;
    });
    probe.remove();

    const cr = (p0,p1,p2,p3,t) =>
      0.5*((2*p1)+(-p0+p2)*t+(2*p0-5*p1+4*p2-p3)*t*t+(-p0+3*p1-3*p2+p3)*t*t*t);

    const N = hems.length;
    function hemPathAt(u){ // u: 0..N-1 の連続パラメータ（1回再生・端はクランプ）
      const last = N - 1;
      const seg = Math.min(Math.floor(u), last - 1);
      const t = u - seg;
      const P0 = hemPts[Math.max(seg-1, 0)], P1 = hemPts[seg],
            P2 = hemPts[seg+1],              P3 = hemPts[Math.min(seg+2, last)];
      let d = 'M0 0H615L';
      for (let i = 0; i <= SAMPLES; i++) {
        d += cr(P0[i][0],P1[i][0],P2[i][0],P3[i][0],t).toFixed(2) + ' '
           + cr(P0[i][1],P1[i][1],P2[i][1],P3[i][1],t).toFixed(2) + ' ';
      }
      return d + 'V0Z';
    }

    let segDuration = parseInt(400, 10); // 1フレーム間の時間(ms)
    let playing = true;
    let u = 0;
    let lastNow = null;

    shape.setAttribute('d', hemPathAt(0));

    function tick(now) {
      if (lastNow === null) lastNow = now;
      u = Math.min(u + (now - lastNow) / segDuration, N - 1);
      lastNow = now;
      shape.setAttribute('d', hemPathAt(u));
      if (u >= N - 1) {              // 最終フレームで停止
        playing = false;
        return;
      }
      if (playing) requestAnimationFrame(tick);
    }

    $link.addEventListener('mouseenter', event => {
      event.preventDefault();
      playing = true;
      lastNow = null;
      requestAnimationFrame(tick);
    });

    $link.addEventListener('mouseleave', event => {
      event.preventDefault();
      u = 0;
      playing = false;
    });
  };
}